export default "__VITE_ASSET__CrQUurDV__"